import plur from "plur";
import { Banner } from "@jsq/ds/core";

type Props = {
  transferCount: number;
};

const TransferSummaryBanner = (props: Props) => {
  const bannerDescription = `You have ${props.transferCount} transfer ${plur("event", props.transferCount)} within the selected date range. They will be synced in addition to the transaction categories you selected. Please review both transactions and transfers below before selecting start sync.`;
  return (
    <Banner
      variant="warning"
      title={`${props.transferCount} ${plur("transfer", props.transferCount)} will be synced as well`}
      description={bannerDescription}
    />
  );
};

export default TransferSummaryBanner;
